/**
 * 数据请求的唯一入口
 */

import docs from "./docs"

export default {
    docs
}